import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgScissorsCut = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 5.952a2.452 2.452 0 1 1 4.904 0 2.452 2.452 0 0 1-4.904 0M5.952 2a3.952 3.952 0 0 0-1.087 7.753l3.907 2.242-3.907 2.253A3.954 3.954 0 0 0 5.952 22a3.952 3.952 0 0 0 1.596-7.568l2.728-1.573 2.76 1.585a.75.75 0 0 0 .747-1.301l-2.003-1.15 9.845-5.676a.75.75 0 0 0-.75-1.3l-10.6 6.112-2.722-1.563A3.953 3.953 0 0 0 5.952 2m6.745 14.23a.75.75 0 0 0 0 1.5h2.846a.75.75 0 0 0 0-1.5zm5.692 0a.75.75 0 1 0 0 1.5h2.846a.75.75 0 0 0 0-1.5zM3.5 18.049a2.452 2.452 0 1 1 4.904 0 2.452 2.452 0 0 1-4.904 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgScissorsCut;
